import { useLocalStorage } from 'usehooks-ts'

import SnippetsOutlinedIcon from '@ant-design/icons/SnippetsOutlined'

import IconButton from '@mui/material/IconButton'

import { QPhrasesDrawer } from '@pages/QPhrases'

export default function QPhrases({ size }) {
  const [open, setOpen] = useLocalStorage('q-phrases-drawer', false)

  return (
    <>
      <IconButton
        id="q-phrases-button"
        color="secondary"
        size={size}
        onClick={() => setOpen((o) => !o)}
        aria-label="QPhrases toggler"
        data-testid="header-q-phrases"
      >
        <SnippetsOutlinedIcon style={{ fontSize: 18 }} />
      </IconButton>
      <QPhrasesDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
